// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__KgClr","productName":"Table_productName__1ngX3"};